export const BACKGROUND_COLOR = '#F6E5D7';
